import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
/**
 * Generated class for the CoDiscoverLaneComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-discover-lane',
  templateUrl: 'co-discover-lane.html'
})
export class CoDiscoverLaneComponent {
  @ViewChild('container') container: ElementRef;
  total: number;
  results: Array<Object>;
  page:number;
  pages:number;
  query:string;
  index:string;
  loading:boolean;

  @Input() name: string;
  @Input() group: string;
  public updateObserver: Subject<Array<number>>;
  constructor() {
    this.results=[];
  }
  reorderItems(ev){
    console.log(ev);
  }
  update(){
    this.updateObserver.next();
  }
  needMore(ev){
    if(ev.status){
      this.loadMore();
    }
  }
  ngOnInit(){
    this.updateObserver =new Subject();
    Observable.fromEvent(this.container.nativeElement, 'scroll').subscribe(
      value=>this.updateObserver.next()
    )
  }
  initResults(result) {
    this.results = result.hits || [];
    this.total = result.nbHits || 0;
    this.page = result.page || 0;
    this.pages = result.nbPages || 0;
    this.query = result.query || "";
    this.index = result.index || "";
  }
  loadMore(){
    if(this.loading)return;
    if(this.page>=this.pages)return;
    //const index = this.algolia.search.initIndex(this.index);
    //this.loading=true;
    //
    //let query: QueryParameters;
    //query = {
    //  query: this.query,
    //  facets: ["f"],
    //  facetFilters: ['f:' + this.name],
    //  attributesToRetrieve:["ti", "ids", "objectID", "src"],
    //  page: this.page+1,
    //  hitsPerPage: 20
    //} as any;
    //
    //index.search(query).then(res=>{
    //    this.results.push(...res.hits);
    //    this.total = res.nbHits;
    //    this.page = res.page;
    //    this.pages = res.nbPages;
    //    this.loading=false;
    //  }).catch(err=>{
    //    // console.error(err);
    //});
  }
}



// WEBPACK FOOTER //
// ./src/components/co-discover-lane/co-discover-lane.ts